import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ScanJobDialogFragment = { __typename: 'ScanJob', id: string, legacyId: number };

export type ScanJobDialogSubJobFragment = { __typename: 'ScanSubJob', id: string, legacyId: number, active: boolean, completed?: string | null, started?: string | null, state: Types.ScanSubJobState, tileX: number, tileY: number, progress?: string | null };

export type ScanJobDialogSubJobAssignmentsQueryVariables = Types.Exact<{
  scanSubJobId: Types.Scalars['ID']['input'];
}>;


export type ScanJobDialogSubJobAssignmentsQuery = { __typename: 'Query', scanSubJob: { __typename: 'ScanSubJob', logAssignments: Array<{ __typename: 'DataObjectAssignment', dataObject: { __typename: 'DataObject', downloadUrl: string } }>, fittingAssignments: Array<{ __typename: 'DataObjectAssignment', dataObject: { __typename: 'DataObject', downloadUrl: string } }>, assemblyAssignments: Array<{ __typename: 'DataObjectAssignment', dataObject: { __typename: 'DataObject', downloadUrl: string } }> } };

export type ScanJobDialogUpdateSubJobMutationVariables = Types.Exact<{
  input: Types.MutationUpdateScanSubJobInput;
}>;


export type ScanJobDialogUpdateSubJobMutation = { __typename: 'Mutation', updateScanSubJob: { __typename: 'ScanSubJob', id: string } };

export type ScanJobDialogQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ScanJobDialogQuery = { __typename: 'Query', item: { __typename: 'ScanJob', id: string, legacyId: number, subJobs: Array<{ __typename: 'ScanSubJob', id: string, legacyId: number, active: boolean, completed?: string | null, started?: string | null, state: Types.ScanSubJobState, tileX: number, tileY: number, progress?: string | null }> } };

export const ScanJobDialogFragmentDoc = gql`
    fragment ScanJobDialog on ScanJob {
  id
  legacyId
  __typename
}
    `;
export const ScanJobDialogSubJobFragmentDoc = gql`
    fragment ScanJobDialogSubJob on ScanSubJob {
  id
  legacyId
  active
  completed
  started
  state
  tileX
  tileY
  progress
}
    `;
export const ScanJobDialogSubJobAssignmentsDocument = gql`
    query scanJobDialogSubJobAssignments($scanSubJobId: ID!) {
  scanSubJob(id: $scanSubJobId) {
    logAssignments: dataObjectAssignments(filter: {assignmentType: ScanLog}) {
      dataObject {
        downloadUrl
      }
    }
    fittingAssignments: dataObjectAssignments(
      filter: {assignmentType: ScanFittingWorkPackage}
    ) {
      dataObject {
        downloadUrl
      }
    }
    assemblyAssignments: dataObjectAssignments(
      filter: {assignmentType: ScanAssemblyWorkPackage}
    ) {
      dataObject {
        downloadUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScanJobDialogSubJobAssignmentsGQL extends Apollo.Query<ScanJobDialogSubJobAssignmentsQuery, ScanJobDialogSubJobAssignmentsQueryVariables> {
    override document = ScanJobDialogSubJobAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScanJobDialogUpdateSubJobDocument = gql`
    mutation scanJobDialogUpdateSubJob($input: MutationUpdateScanSubJobInput!) {
  updateScanSubJob(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScanJobDialogUpdateSubJobGQL extends Apollo.Mutation<ScanJobDialogUpdateSubJobMutation, ScanJobDialogUpdateSubJobMutationVariables> {
    override document = ScanJobDialogUpdateSubJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScanJobDialogDocument = gql`
    query scanJobDialog($id: ID!) {
  item: scanJob(id: $id) {
    subJobs {
      ...ScanJobDialogSubJob
    }
    ...ScanJobDialog
  }
}
    ${ScanJobDialogSubJobFragmentDoc}
${ScanJobDialogFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScanJobDialogGQL extends Apollo.Query<ScanJobDialogQuery, ScanJobDialogQueryVariables> {
    override document = ScanJobDialogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }